<template>
    <slot
        :thumb-options="thumbOptions"
        :gallery-options="galleryOptions"
        :selected-variant="selectedVariant"
        :wishlist-loading="wishlistLoading"
        :order-sample-loading="orderSampleLoading"
        :order-sample-error-message="orderSampleErrorMessage"
        :lightbox-items="lightboxItems"
        :lightbox-open="lightboxOpen"
        :set-lightbox-open="setLightboxOpen"
        :variant="variant"
        :is-favorite="isFavorite"
        :is-in-cart="isInCart"
        :variants-options="variantsOptions"
        :selected-image-variant="selectedImageVariant"
        :toggle-favorite="toggleFavorite"
        :order-sample="orderSample"
        :remove-sample="removeSample"
    >
    </slot>
</template>

<script>
export default {
    props: {
        productId: {
            type: Number,
            required: true,
        },

        variants: {
            type: Array,
            required: true,
        },

        initialVariant: {
            type: Number,
            required: true,
        },

        lightboxItems: {
            type: Array,
            default: () => { return []; },
        },
    },

    data() {
        const thumbOptions = {
            speed: 300,
            spaceBetween: 8,
            slidesPerView: 3,
            updateOnImagesReady: true,
            preloadImages: false,
        };

        const galleryOptions = {
            speed: 300,
            spaceBetween: 8,
            autoHeight: true,
            updateOnImagesReady: true,
            preloadImages: false,
            thumbs: {
                swiper: {
                    el: '.swiper-container-thumbs',
                    ...thumbOptions,
                },
            },
        };

        return {
            galleryOptions,
            thumbOptions,
            selectedVariant: this.initialVariant,
            wishlistLoading: false,
            orderSampleLoading: false,
            orderSampleErrorMessage: '',
            lightboxOpen: false,
        };
    },

    computed: {
        variant() {
            return this.variants.find((variant) => { return parseInt(variant.id) === this.selectedVariant; });
        },
        isFavorite() {
            return this.$store.getters['wishlist/isInWishlist'](this.productId);
        },
        isInCart() {
            return this.$store.getters['cart/isInCart'](this.selectedVariant);
        },
        variantsOptions() {
            return this.variants.map((variant) => {
                const length = Math.round(variant.length);
                const width = Math.round(variant.width);
                const price = variant.pricePerM2;

                return {
                    value: variant.id,
                    label: `${variant.title} — ${length}×${width} — ${price} m²`,
                };
            });
        },
        selectedImageVariant() {
            if (this.variant.images > 0) {
                return this.selectedVariant;
            }

            for (const variant of this.variants) {
                if (variant.images > 0) {
                    return variant.id;
                }
            }

            return null;
        },
    },

    methods: {
        async toggleFavorite() {
            this.wishlistLoading = true;

            await this.$store.dispatch('wishlist/toggleWishlist', this.productId);

            this.wishlistLoading = false;
        },
        async orderSample() {
            this.orderSampleLoading = true;
            this.orderSampleErrorMessage = '';

            const data = await this.$store.dispatch('cart/addToCart', this.selectedVariant);

            if (!data) {
                // eslint-disable-next-line
                    // this.orderSampleErrorMessage = Object.values(data.errors)[0][0];
                this.orderSampleErrorMessage = `"${this.variant.title}" is currently out of stock.`;
            }

            this.orderSampleLoading = false;
        },
        async removeSample() {
            this.orderSampleLoading = true;
            this.orderSampleErrorMessage = '';

            await this.$store.dispatch('cart/removeFromCart', this.selectedVariant);

            this.orderSampleLoading = false;
        },

        setLightboxOpen(value) {
            this.lightboxOpen = value;
        },
    },
};
</script>
